'use client'

import classes from './card-form-alert.module.css'

import { Box, Group, Text } from '@mantine/core'
import { ShieldX } from 'lucide-react'
import { useTranslations } from 'next-intl'

type CardFormAlertProps = {
  message: string | null
}

const CardFormAlert = (props: CardFormAlertProps) => {
  const { message } = props

  const t = useTranslations('auth')

  if (!message) return null

  return (
    <Box className={classes.box}>
      <Group gap='sm'>
        <ShieldX size={16} strokeWidth={2} />
        <Text
          ff='text'
          fz='sm'
          dangerouslySetInnerHTML={{ __html: t(message) }}
          style={{ flex: 1 }}
        />
      </Group>
    </Box>
  )
}

export default CardFormAlert
